import { render } from "./AsahiDiscountMessage.vue?vue&type=template&id=8ccc2304&scoped=true&ts=true"
import script from "./AsahiDiscountMessage.vue?vue&type=script&lang=ts"
export * from "./AsahiDiscountMessage.vue?vue&type=script&lang=ts"

import "./AsahiDiscountMessage.vue?vue&type=style&index=0&id=8ccc2304&scoped=true&lang=scss"

import exportComponent from "/srv/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ccc2304"]])

export default __exports__